// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".helpdesk{\n    font-size: 16px;\n    font-weight: 700;\n}", "",{"version":3,"sources":["webpack://./src/components/HelpDesk/Helpdesk.styles.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".helpdesk{\n    font-size: 16px;\n    font-weight: 700;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
